import type { ReactNode } from 'react';
import React from 'react';

function Body({ children }: { children?: ReactNode }) {
  return (
    <div className="Offer-body">
      <div className="Offer-summary">{children}</div>
    </div>
  );
}

Body.displayName = 'Body';

export { Body };
